<template>
  <div id="app">
    <slide-verify
      ref="slideblock"
      @success="onSuccess"
      @again="onAgain"
      @fulfilled="onFulfilled"
      @fail="onFail"
      @refresh="onRefresh"
      :slider-text="text"
      :imgs="imgs"
      :accuracy="accuracy"
    ></slide-verify>
    <div>{{ msg }}</div>
    <!-- <button class="btn" @click="handleClick">在父组件可以点我刷新哦</button> -->
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import { getValidCodeApi } from '../../api/answer.js';
import SlideVerify from './components/slide-verify.vue';
import img0 from './assets/img.jpg';
import img1 from './assets/img1.jpg';
import img2 from './assets/img2.jpg';
import img3 from './assets/img3.jpg';
import img4 from './assets/img4.jpg';
import img5 from './assets/img5.jpg';
export default {
  name: 'App',
  components: {
    SlideVerify
  },
  data() {
    return {
      msg: '',
      text: '向右滑动->',
      imgs: [img0, img1, img2, img3, img4, img5],
      accuracy: 5, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      validCode: ''
    };
  },
  props: {
    phone: {
      type: String,
      default: ''
    },
    queryForm: {
      type: Object,
      default: () => ({})
    },
    formId: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if (this.phone) {
      this.getValidCodeFn();
    }
  },
  methods: {
    // 定义一个函数来生成随机盐（这里简单使用Math.random生成一个字符串作为示例）
    generateSalt() {
      let salt = '';
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (let i = 0; i < 16; i++) {
        // 盐的长度可以根据需要调整
        salt += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return salt;
    },

    // 定义一个函数来对密码和盐进行哈希
    hashPasswordWithSalt(password, salt) {
      // 这里简单地将盐和密码拼接起来，然后进行SHA-256哈希
      // 注意：这种方法并不安全，因为它容易受到时间和空间权衡攻击（如彩虹表攻击的一种变体）
      // 在实际应用中，应该使用更安全的机制，如bcrypt、scrypt或argon2
      const combined = password + salt;
      const hash = CryptoJS.SHA256(combined).toString(CryptoJS.enc.Hex);
      return { hash, salt }; // 返回哈希值和盐
    },
    md5Validate(str) {
      const hash = CryptoJS.MD5(str).toString();
      return hash;
    },
    getValidCodeFn() {
      getValidCodeApi({
        phone: this.queryForm.phone,
        id: this.formId,
        collegeId: this.queryForm.collegeId,
        s: this.queryForm.s
      }).then(res => {
        if (res.data.success) {
          this.validCode = res.data.data;
        }
      });
    },
    onSuccess(times) {
      // this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`

      //   const password = 'mySuperSecretPassword';
      //   const salt = this.generateSalt();
      //   const { hash, salt: storedSalt } = this.hashPasswordWithSalt(password, salt);

      //   console.log('Hash:', hash);
      //   console.log('Salt:', storedSalt);
      const validCode = this.md5Validate(this.validCode + 'A7$t2Z');
      // 触发父组件回调
      this.$emit('handelSuccess', validCode);
    },
    onFail() {
      //   console.log('验证不通过');
      this.$message.error('验证失败 , 请重试!');
      this.msg = '';
    },
    onRefresh() {
      console.log('点击了刷新小图标');
      this.msg = '';
    },
    onFulfilled() {
      console.log('刷新成功啦！');
    },
    onAgain() {
      console.log('检测到非人为操作的哦！');
      this.msg = 'try again';
      // 刷新
      this.handleClick();
    },
    handleClick() {
      this.$refs.slideblock.reset();
      this.msg = '';
    }
  }
};
</script>

<style>
/* #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
} */
.btn {
  margin-top: 20px;
  outline: 0;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  color: #fff;
  background-color: #1890ff;
  cursor: pointer;
}
.btn:active {
  box-shadow: 1px 5px 0 rgba(0, 0, 0, 0.1) inset;
}
</style>



// WEBPACK FOOTER //
// src/components/slideVerify/index.vue